// extracted by mini-css-extract-plugin
export default {"toastBox":"Tiyxkp","icon":"_FokCm","text":"G1bvaL"};